export default __webpack_public_path__ + "static/31-d9dbe37bc2661f745b715bcb1b197389.png";